import FullscreenSpin from './FullscreenSpin'

export default FullscreenSpin
